var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 41,
    viewBox: "0 0 48 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 3C27 3.8885 26.6138 4.68678 26 5.2361V9H36C39.3138 9 42 11.6863 42 15V35C42 38.3138 39.3138 41 36 41H12C8.6863 41 6 38.3138 6 35V15C6 11.6863 8.6863 9 12 9H22V5.2361C21.3862 4.68678 21 3.8885 21 3C21 1.34314 22.3432 0 24 0C25.6568 0 27 1.34314 27 3ZM12 13C10.8954 13 10 13.8954 10 15V35C10 36.1046 10.8954 37 12 37H36C37.1046 37 38 36.1046 38 35V15C38 13.8954 37.1046 13 36 13H26H22H12ZM4 19H0V31H4V19ZM44 19H48V31H44V19ZM18 28C19.6569 28 21 26.6568 21 25C21 23.3432 19.6569 22 18 22C16.3431 22 15 23.3432 15 25C15 26.6568 16.3431 28 18 28ZM30 28C31.6568 28 33 26.6568 33 25C33 23.3432 31.6568 22 30 22C28.3432 22 27 23.3432 27 25C27 26.6568 28.3432 28 30 28Z",
    fill: "url(#paint0_linear_25519_1568)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25519_1568",
    x1: 0,
    y1: 0,
    x2: 18.5115,
    y2: 43.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD2BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.f8c6b590ed7e952e5bf3c02754f22fc7.svg";
export { ForwardRef as ReactComponent };